import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button, notification,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import DetailsFields from '../detailsFields/DetailsFields';
import './Details.scss';

const Details = (props) => {
  const {
    serviceRequestParameters, nextPage, previousPage,
  } = props;

  const [formInstance] = Form.useForm();
  const handleSubmit = (values) => {
    const fields = Object.entries(values);
    let verifyValorUnitario = formInstance.getFieldValue('POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO');
    let verifyValorTotal = formInstance.getFieldValue('POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL');
    const verifyCondicaoPagamento = formInstance.getFieldValue('POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-CONDICAO_PAGAMENTO');
    const verifyFormaPagamento = formInstance.getFieldValue('POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-FORMA_PAGAMENTO');

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        fields.map((item) => {
          if (item[0] === 'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO') {
            item[1] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
          }

          if (item[0] === 'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL') {
            item[1] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
          }
        });
      } else {
        fields.map((item) => {
          if (item[0] === 'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO') {
            item[1] = null;
          }

          if (item[0] === 'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL') {
            item[1] = null;
          }
        });
      }

      nextPage({
        ...serviceRequestParameters,
        serviceRequestFieldInputList: fields.map((fieldValue) => {
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1] || '',
          });
        }).filter((fieldValue) => {
          return fieldValue.value != null
            || fieldValue.idCode.includes('VALOR_UNITARIO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('OBSERVACOES');
        }),
      });
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
    }
  };

  return (
    <div className="MontagemEquipamentoDetails">
      <Row
        justify="space-between"
        className="MontagemEquipamentoDetails__TitleRow"
      >
        <Col
          className="MontagemEquipamentoDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="MontagemEquipamentoDetails__Title"
          >
            Novo Serviço: Pós-vendas
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="MontagemEquipamentoDetails__ContentRow"
      >
        <Col
          span={24}
          className="MontagemEquipamentoDetails__ContentColumn"
        >
          <Card
            className="MontagemEquipamentoDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="MontagemEquipamentoDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="MontagemEquipamentoDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="MontagemEquipamentoDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo) => {
                      console.log('MontagemEquipamentoDetails onFinishFailed', errorInfo);
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                    mode="CREATE"
                  />
                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="MontagemEquipamentoDetails__LandAndSummaryColumn"
              >
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="MontagemEquipamentoDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="MontagemEquipamentoDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="MontagemEquipamentoDetails__BackButton"
                  onClick={() => previousPage()}
                >
                  <ArrowLeftIcon className="MontagemEquipamentoDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="MontagemEquipamentoDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="MontagemEquipamentoDetails__ContinueButton"
                  onClick={
                    (eventt) => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.string,
    nameModel: PropTypes.string,
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
